import GuidePage from './guide/guide';

export default GuidePage;
